const isLocal = process.env.NODE_ENV === 'development';

export const logoutUrl = isLocal
  ? 'http://127.0.0.1:3001/auth/logout'
  : '/auth/logout';
